import React from "react";
import DashboardLoanDetails from "../../../components/DashboardLoanDetails";

function LoanDashboardOverview() {
  return (
    <div className=" w-full  flex gap-2 items-center justify-around rounded-md  px-4 pt-4">
      <DashboardLoanDetails
        label={"Total active loans"}
        number={12}
        type={" Loans"}
        className={"text-green-400"}
      />
      <DashboardLoanDetails
        label={"Pending loan requests"}
        number={12}
        type={" pending requests"}
        className={"text-yellow-400"}
      />
      <DashboardLoanDetails
        label={"Open disputes"}
        number={23}
        type={" Disputes"}
        className={"text-red-400"}
      />
    </div>
  );
}

export default LoanDashboardOverview;
